import React from "react";
import { Button, Popover, List, Typography } from "antd";
import { PhoneOutlined, InfoOutlined } from "@ant-design/icons";

const wellnessContacts = [
  {
    title: "Tele MANAS (Govt. of India)",
    phone: "14416 / 1-800-891-4416",
    desc: "24/7, multiple languages, free"
  },
  {
    title: "KIRAN (Ministry of Social Justice & Empowerment)",
    phone: "1800-599-0019",
    desc: "24/7, for mental illness"
  },
  {
    title: "NIMHANS (Psychological Support)",
    phone: "080-46110007",
    desc: ""
  },
];

export default function FloatingActionButtons() {
  const content = (
    <div style={{ width: 260 }}>
      <Typography.Title level={5} style={{ marginBottom: 8, textAlign: "center", fontSize: 20 }}>
        Mental Wellness Priority<br />No Stigma in Seeking Help
      </Typography.Title>

      <List
        size="small"
        dataSource={wellnessContacts}
        renderItem={(item) => (
          <List.Item>
            <div>
              <Typography.Text strong>{item.title}</Typography.Text>
              <br />
              <a href={`tel:${item.phone.replace(/[^0-9]/g, "")}`}>
                <PhoneOutlined /> {item.phone}
              </a>
              <br />
              <p>{item.desc}</p>
            </div>
          </List.Item>
        )}
      />
    </div>
  );
  return (
    <div>
      <Popover content={content} trigger="click" placement="leftBottom">
        <Button
          type="primary"
            
          size="large"
          icon={<InfoOutlined />}
          style={{
            position: "fixed",
            bottom: 24,
            right: 24,
            zIndex: 1000,
            backgroundColor: "#ff4d4f",
            borderColor: "#ff4d4f",
            borderRadius: 20,
            fontWeight: 700
          }}
        >
        Mental Wellness Priority
        </Button>
      </Popover>
    </div>
  );
}
